export const and = 'AND';
export const or = 'OR';

const conditionOperators = [and, or];

export default conditionOperators;
